<template>
    <el-dialog
        class="milestone"
        :visible.sync="milestoneVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="里程碑"
    >
        <div class="container">
            <el-table
                border
                :data="tableData"
                ref="tableData"
                highlight-current-row
                height="90%"
                :cell-style="{ fontSize: '12px' }"
                :header-cell-style="{ fontSize: '12px' }"
            >
                <el-table-column label="负责人" property="user_name" align="center"></el-table-column>
                <el-table-column label="汇报时间" property="create_time" align="center" width="160"></el-table-column>
                <el-table-column label="进度" align="center">
                    <template slot-scope="scope">{{ scope.row.progress }}%</template>
                </el-table-column>
                <el-table-column label="未开始" property="not_start" align="center"></el-table-column>
                <el-table-column label="进行中" property="in_progress" align="center"></el-table-column>
                <el-table-column label="已完成" property="finish_num" align="center"></el-table-column>
                <el-table-column label="已结束" property="close_num" align="center"></el-table-column>
                <el-table-column label="总进度" align="center">
                    <template slot-scope="scope">{{ scope.row.total_progress }}%</template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="90">
                        <template slot-scope="scope">
                            <div class="color-blue">
                                <div class="color-blue">
                                    <el-button
                                        type="text"
                                        size="small"
                                        @click="detail(scope.row)"
                                        >查看</el-button
                                    >
                                </div>
                            </div>
                        </template>
                    </el-table-column>
            </el-table>
        <pagination :paginationData="paginationData" @paginationChange="paginationChange"></pagination>
        <milestoneDetail :milestoneDetailVisible.sync="milestoneDetailVisible" :tableItem="tableRow"></milestoneDetail>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="milestoneVisible = false">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import pagination from "@/comon/components/pagination";
import { mapState } from "vuex";
export default {
    data() {
        return {
            tableData: [],
            paginationData: {
                page: 1,
                "per-page": 20,
                total: "",
            },
            milestoneDetailVisible:false,
            tableRow:{}
        };
    },
    props: {
        milestoneVisible: Boolean,
        tableItem: Object
    },
    methods: {
        projectMilestone() {
            oaApi
                .projectMilestone({ project_id: this.tableItem.id,...this.paginationData }, "get")
                .then(res => {
                    //console.log(res);
                    if (res.code == 200) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                    }
                });
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.projectMilestone();
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:milestoneVisible", false);
        },
        detail(row){
            this.tableRow = row;
            this.milestoneDetailVisible = true;
            console.log(row);
        }
    },
    watch: {
        milestoneVisible: {
            handler(newValue) {
                if (newValue) {
                    this.projectMilestone();
                }
            }
        }
    },
    components: {
        pagination: pagination,
        milestoneDetail: ()=>import("./milestoneDetail.vue")
    },
    computed: {}
};
</script>

<style lang="scss" scoped>
.milestone {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
        height: 500px;
    }
}
</style>
